import { FunctionalComponent, render } from './component';

interface ComponentPair<T> {
  component: FunctionalComponent<T>;
  element: HTMLElement | null;
}

/**
 * Componentを束ねるクラス
 * 1画面1つの想定
 */
export abstract class RootContainer<T> {
  protected components: ComponentPair<T>[] = [];

  protected mount(component: FunctionalComponent<T> | null, el: string) {
    if (component) {
      this.components.push({ component: component, element: this.getElement(el) });
    }
  }

  protected mountByCssSelector(component: FunctionalComponent<T> | null, cssSelector: string) {
    if (component) {
      this.components.push({ component: component, element: document.querySelector(cssSelector)})
    }
  }

  getElement(el: string): HTMLElement | null {
    return document.getElementById(el.replace(/^#/, ''));
  }

  protected update(model: T) {
    this.components.forEach((it) => render(it.component(model), it.element));
  }
}
